






























































































































































































































































































































































































































































































































































































































































// Vue
import Vue, { PropType } from "vue";
// Vuex
import { mapActions, mapGetters } from "vuex";
// Vuelidate
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// moment.js
import moment from "moment";

import {
  ApplicationModel,
  ContactModel,
  UpdateContactModel,
  CreateOrUpdateJobModel,
  CreateOrUpdateJobDriverModel,
  ContactClient,
  CustomerModel,
  DeliveryDateType,
  DeliveryDetailsModel,
  DriverModel,
  DriverNoteModel,
  JobDriverModel,
  JobModel,
  JobSiteModel,
  UpdateJobSiteModel,
  JobSiteClient,
  JobImageModel,
  JobType,
  JobMaterialModel,
  JobQuantityModel,
  MaterialModel,
  PriceType,
  QuantityType,
  QuantityModel,
  QuarryModel,
  UpdateCustomerModel,
  UpdateDeliveryDetailsModel,
  UpdateJobSiteDetailsModel,
  UpdateJobMaterialModel,
  UpdateJobQuantityModel
} from "@/core/api/apiClient";

// enum mappings
import mapPriceType from "@/core/helpers/enum_mappings/PriceType";
import mapQuantityType from "@/core/helpers/enum_mappings/QuantityType";
import mapJobType from "@/core/helpers/enum_mappings/JobType";
import mapDeliveryDateType from "@/core/helpers/enum_mappings/DeliveryDateType";
// Services
import AdminService from "@/views/admin/Admin.service";
import JobsService from "@/views/dispatch/jobs/Jobs.service";
// Components
import ImagesDialog from "@/views/calendar/ImagesDialog.vue";
import ExportJob from "@/core/components/content/ExportJob.vue";
import UpdateQuarryDialog from "@/views/admin/_dialogs/quarries/UpdateQuarryDialog.vue";
import ConfirmationDialog from "@/core/components/content/_dialogs/ConfirmationDialog.vue";
import CreateMaterialDialog from "@/views/admin/_dialogs/materials/CreateMaterialDialog.vue";
import CreateApplicationDialog from "@/views/admin/_dialogs/applications/CreateApplicationDialog.vue";
import CreateQuantityDialog from "@/views/admin/_dialogs/quantities/CreateQuantityDialog.vue";
import CreateContactDialog from "@/views/dispatch/customers/_dialogs/contact/CreateContactDialog.vue";
import CreateJobsiteDialog from "@/views/dispatch/customers/_dialogs/job-site/CreateJobsiteDialog.vue";
import CreateCustomerDialog from "@/views/dispatch/customers/_dialogs/customer/CreateCustomerDialog.vue";
import { JobSchedulerSelection } from "../../scheduler/_models/jobSchedulerSelection.model";
export default Vue.extend({
  name: "UpdateJobDialog",
  components: {
    ExportJob,
    ImagesDialog,
    UpdateQuarryDialog,
    ConfirmationDialog,
    CreateJobsiteDialog,
    CreateContactDialog,
    CreateCustomerDialog,
    CreateMaterialDialog,
    CreateQuantityDialog,
    CreateApplicationDialog
  },
  props: {
    isViewing: Boolean,
    job: Object as PropType<JobModel>,
    drivers: Array as PropType<DriverModel[]>,
    inputData: Object as PropType<JobSchedulerSelection>,
    noActivators: Boolean,
    showDialog: { type: Boolean, default: undefined }
  },
  data() {
    const priceTypes = Object.values(PriceType).map((value) => ({
      label: mapPriceType(value),
      value: value
    }));
    const quantityTypes = Object.values(QuantityType).map((value) => ({
      label: mapQuantityType(value),
      value: value
    }));
    const jobTypes = Object.values(JobType).map((value) => ({
      label: mapJobType(value),
      value: value
    }));
    const deliveryDateTypes = Object.values(DeliveryDateType).map((value) => ({
      label: mapDeliveryDateType(value),
      value: value
    }));
    return {
      dialog: false,
      isLoading: false,
      timeModal: false,
      assignedDrivers: [] as JobDriverModel[],
      // Dropdown data
      priceTypes: priceTypes,
      contacts: [] as ContactModel[],
      jobSites: [] as JobSiteModel[],
      quantityTypes: quantityTypes,
      jobTypes: jobTypes,
      deliveryDateTypes: deliveryDateTypes,
      // Material
      materialsData: [] as MaterialModel[],
      assignedMaterial: null as JobMaterialModel | null,

      // Quantity
      quantitiesData: [] as QuantityModel[],
      assignedQuantity: null as JobQuantityModel | null,
      selectedQuantityType: QuantityType.Loads,
      // Applications
      applicationsData: [] as ApplicationModel[],
      selectedApplications: [] as ApplicationModel[],

      selectedJobType: JobType.Sling,
      applicationIsHourly: false,
      applicationIsMulti: false,
      // Quarries
      quarriesData: undefined as QuarryModel[] | undefined,
      selectedQuarry: undefined as QuarryModel | undefined,

      // Customer
      customersData: [] as CustomerModel[],
      selectedCustomer: undefined as CustomerModel | undefined,
      selectedContact: undefined as ContactModel | undefined,
      IsPhoneHiddenToDriver: false,
      selectedJobSite: undefined as JobSiteModel | undefined,
      // Jobsite Details
      lotNumber: "",
      unitNumber: "",
      block: "",
      municipal: "",
      po: "",
      deliveryDetailNotes: "",
      // Jobsite Notes
      jobsiteNotes: undefined as string | undefined,
      // Delivery Details
      // Datepicker
      deliveryDate: undefined as string | undefined,
      dateMenu: false,
      jobDuration: undefined as number | undefined,
      // Timepicker
      deliveryTime: moment(new Date()).format("HH:mm").toString(),
      timePickerMenu: false,
      // Delivery Date Type
      selectedDeliveryDateType: DeliveryDateType.At,
      // Price Type
      price: "",
      selectedPriceType: PriceType.TonYard,
      isTaxable: true,
      taxRate: 13,
      // Notes
      deliveryDetails: {} as DeliveryDetailsModel,
      driverNotes: [] as DriverNoteModel[],
      // Images
      images: [] as JobImageModel[],
      // Is Job Complete
      isCompleted: false,
      // First Available Job Time
      firstAvailableTime: undefined as Date | undefined
    };
  },
  mixins: [validationMixin],
  validations: {
    // Customer Info
    selectedCustomer: { required },
    // Delivery Details
    deliveryDate: { required },
    deliveryTime: { required }
  },
  methods: {
    ...mapActions("customers", {
      setCustomer: "setCustomer"
    }),
    initializeFormValues(): void {
      this.getAllMaterials();
      this.getAllQuantities();
      this.getAllApplications();
      this.getAllQuarries();
      this.getAllCustomers();
      this.deliveryDate = moment(new Date()).format("YYYY-MM-DD");
      this.getFirstAvailableTime();
      if (this.inputData) {
        const startDate = moment(this.inputData.startDate);
        this.deliveryDate = startDate.format("YYYY-MM-DD");
        this.deliveryTime = startDate.format("HH:mm");
        this.assignedDrivers.push(
          new JobDriverModel({
            jobDriverId: "",
            driverId: this.inputData.driver.driverId,
            firstName: this.inputData.driver.firstName,
            lastName: this.inputData.driver.lastName
          })
        );
      }
      if (this.job) {
        // Drivers
        this.assignedDrivers = this.job.drivers ?? [];
        // Material
        this.assignedMaterial = this.job.material ?? null;
        // Quantity
        this.assignedQuantity = this.job.quantity ?? null;
        this.selectedQuantityType = this.job.quantityType ?? QuantityType.Loads;
        // Application
        this.selectedApplications = this.job.applications
          .map((a) => a.application)
          .filter((app): app is ApplicationModel => app !== undefined);
        this.selectedJobType = JobType[this.job.jobType];
        this.applicationIsHourly = this.job.hourly;
        this.applicationIsMulti = this.job.applications.length > 1;
        // Customer
        this.selectedCustomer = this.job.customer;
        this.getCustomerInfo(this.selectedCustomer);
        this.selectedContact = this.job.customerContact;
        this.selectedJobSite = this.job.jobSite;
        // Jobsite Details
        this.lotNumber = this.job.jobSiteDetails?.lot!;
        this.unitNumber = this.job.jobSiteDetails?.unit!;
        this.block = this.job.jobSiteDetails?.block!;
        this.municipal = this.job.jobSiteDetails?.municipal!;
        this.po = this.job.jobSiteDetails?.po!;
        this.deliveryDetailNotes = this.job.deliveryDetails?.notes!;
        // Jobsite Notes
        this.jobsiteNotes = this.job.jobSite?.notes;
        // Delivery Details
        // DatePicker
        this.deliveryDate = moment(this.job.deliveryDetails?.deliveryDate).format("YYYY-MM-DD");
        this.dateMenu = false;
        // TimePicker
        this.deliveryTime = moment(this.job.deliveryDetails?.deliveryDate).format("HH:mm").toString();
        this.timePickerMenu = false;
        // Delivery Date Type
        this.selectedDeliveryDateType = DeliveryDateType[this.job.deliveryDetails?.deliveryDateType!];
        // Price Type
        this.price = this.job.deliveryDetails?.price!;
        this.selectedPriceType = this.job.deliveryDetails?.priceType!;
        this.isTaxable = this.job.deliveryDetails?.isTaxable ?? false;
        // Notes
        this.deliveryDetails = this.job.deliveryDetails!;
        this.driverNotes = this.job.driverNotes!;
        // Images
        this.images = this.job.jobImages;

        // Is Job Complete
        this.isCompleted = this.job.completed;
        // Get Job Duration
        this.jobDuration = this.getJobDuration(
          this.job.deliveryDetails?.deliveryDate,
          this.job.deliveryDetails?.estimateEndDate
        );
      }
    },
    getAllApplications(setSelectedValue?: boolean): void {
      this.isLoading = true;
      AdminService.getAllApplications(this.currentUser.clientId)
        .then((data: ApplicationModel[]) => {
          if (!data) return;
          this.applicationsData = data;
          // Set selectedValue to last element in the array.
          if (setSelectedValue)
            this.selectedApplications.push(this.applicationsData[this.applicationsData.length - 1]);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getAllMaterials(setSelectedValue?: boolean): void {
      this.isLoading = true;
      AdminService.getAllMaterials(this.currentUser.clientId)
        .then((data: MaterialModel[]) => {
          if (!data) return;
          this.materialsData = data;
          // Set selectedValue to last element in the array.
          if (setSelectedValue)
            this.selectedMaterial = this.materialsData[this.materialsData.length - 1];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getAllQuantities(setSelectedValue?: boolean): void {
      this.isLoading = true;
      AdminService.getAllQuantities(this.currentUser.clientId)
        .then((data: QuantityModel[]) => {
          if (!data) return;
          this.quantitiesData = data;
          // Set selectedValue to last element in the array.
          if (setSelectedValue)
            this.selectedQuantity = this.quantitiesData[this.quantitiesData.length - 1];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getAllQuarries(): void {
      AdminService.getAllQuarries(this.currentUser.clientId).then((data: QuarryModel[]) => {
        if (!data) return;
        this.quarriesData = data;
      });
    },
    getAllCustomers(): void {
      this.isLoading = true;
      AdminService.getAllCustomers(this.currentUser.clientId, true).then((data: CustomerModel[]) => {
        if (!data) return;
        // if selectedCustomer is not undefined then it is a new customer
        if (this.selectedCustomer) {
          var customerIndex = data.findIndex((x) => x.name == this.selectedCustomer?.name);
          this.selectedCustomer = data[customerIndex];
          this.getCustomerInfo(this.selectedCustomer);
        }
        this.customersData = data;
        this.isLoading = false;
      });
    },
    getCustomerInfo(customer: CustomerModel | undefined): void {
      if (!customer) return;
      if (!customer.customerId) return;
      this.isLoading = true;
      this.contacts = [] as ContactModel[];
      this.jobSites = [] as JobSiteModel[];
      // Get Customer Contacts
      AdminService.getAllCustomerContacts(this.currentUser.clientId, customer.customerId).then(
        (data: ContactModel[]) => {
          if (!data) return;
          this.contacts = data;
        }
      );

      // Get Customer Jobsites
      AdminService.getAllCustomerJobsites(this.currentUser.clientId, customer.customerId, true).then(
        (data: JobSiteModel[]) => {
          if (!data) return;
          this.jobSites = data;
        }
      );

      this.isLoading = false;
    },
    clearSelectedCustomerInfo(): void {
      this.jobsiteNotes = undefined;
      this.selectedJobSite = undefined;
      this.selectedContact = undefined;
    },
    /**
     * Creates/Updates the Job.
     * @author Nick Brahimir
     */
    submit(isDuplicateJob?: boolean): void {
      this.isLoading = true;

      // Build deliveryDate
      let payloadDeliveryDate: any;
      payloadDeliveryDate = moment(this.deliveryDate + "T" + this.deliveryTime).toDate();

      // Set the deliveryTime to the firstAvailableTime if the deliveryDateType is "Anytime"
      if (
        this.selectedDeliveryDateType === DeliveryDateType.NotConfirmed ||
        this.selectedDeliveryDateType === DeliveryDateType.WillCall ||
        this.selectedDeliveryDateType === DeliveryDateType.Anytime ||
        this.selectedDeliveryDateType === DeliveryDateType.ASAP
      ) {
        payloadDeliveryDate = this.firstAvailableTime;
      }

      // build payload
      const payload: CreateOrUpdateJobModel = new CreateOrUpdateJobModel({
        jobId: this.job && !isDuplicateJob ? this.job.jobId : undefined,
        customerId: this.selectedCustomer?.customerId ?? undefined,
        jobSiteId: this.selectedJobSite?.jobSiteId ?? undefined,
        jobSiteDetails: new UpdateJobSiteDetailsModel({
          lot: this.lotNumber ?? undefined,
          unit: this.unitNumber ?? undefined,
          block: this.block ?? undefined,
          municipal: this.municipal ?? undefined,
          po: this.po ?? undefined
        }),
        material: this.assignedMaterial
          ? new UpdateJobMaterialModel({
              jobMaterialId:
                isDuplicateJob || this.assignedMaterial.jobMaterialId === ""
                  ? undefined
                  : this.assignedMaterial.jobMaterialId ?? undefined,
              customName: undefined,
              materialId: this.assignedMaterial.material?.materialId ?? undefined
            })
          : undefined,
        quantity: this.assignedQuantity
          ? new UpdateJobQuantityModel({
              jobQuantityId:
                isDuplicateJob || this.assignedQuantity.jobQuantityId === ""
                  ? undefined
                  : this.assignedQuantity.jobQuantityId ?? null,
              customName: undefined,
              quantityId: this.assignedQuantity.quantity?.quantityId
            })
          : undefined,
        quantityType: this.selectedQuantityType ?? null,
        customerContactId: this.selectedContact?.contactId ?? undefined,
        applications: this.selectedApplications.map((x) => x.applicationId),
        hourly: this.applicationIsHourly ?? false,
        jobType: this.selectedJobType ?? JobType.Sling,
        deliveryDetails: new UpdateDeliveryDetailsModel({
          deliveryDate: payloadDeliveryDate ?? undefined,
          deliveryDateType: this.selectedDeliveryDateType ?? DeliveryDateType.At,
          price: this.price ?? undefined,
          priceType: this.selectedPriceType ?? PriceType.TonYard,
          isTaxable: this.isTaxable ?? false,
          notes: this.deliveryDetailNotes ?? undefined
        }),
        isPhoneHiddenToDriver: this.IsPhoneHiddenToDriver ?? undefined,
        drivers: isDuplicateJob
          ? []
          : this.assignedDrivers.map(
              (d) =>
                new CreateOrUpdateJobDriverModel({
                  jobDriverId: isDuplicateJob || d.jobDriverId === "" ? undefined : d.jobDriverId,
                  driverId: d.driverId,
                  quarryId: d.quarry?.quarryId ?? undefined
                })
            ),
        isCompleted: false
      });
      if (!this.job || (this.job && isDuplicateJob)) {
        //create or clone job
        if (this.inputData?.endDate) {
          // Set end date if initial data was set.
          payload.deliveryDetails!.estimateEndDate = moment(this.inputData.endDate).toDate();
        } else {
          // Otherwise, default EstimateEndDate to 1 hour from DeliveryDate.
          payload.deliveryDetails!.estimateEndDate = moment(payloadDeliveryDate)
            .add(1, "hours")
            .toDate();
        }
        // If we're duplicating a Job, include the appropriate properties.
        if (this.job && isDuplicateJob) {
          payload.deliveryDetails!.estimateEndDate =
            this.job.deliveryDetails?.estimateEndDate ?? undefined;
        }
      } else if (this.job) {
        //update job
        payload.isCompleted = this.isCompleted ?? false;

        // Set the EstimateEndDate using jobDuration.
        if (this.jobDuration) {
          payload.deliveryDetails!.estimateEndDate = moment(payloadDeliveryDate)
            .add(this.jobDuration, "hours")
            .toDate();
        }
        // If Job doesn't have an EstimateEndDate; default to 1 hour from DeliveryDate.
        if (!payload.deliveryDetails!.estimateEndDate) {
          payload.deliveryDetails!.estimateEndDate = moment(payload.deliveryDetails!.deliveryDate)
            .add(1, "hours")
            .toDate();
        }
      }
      JobsService.createOrUpdateJob(this.currentUser.clientId, payload)
        .then(() => {
          this.updateStore();
        })
        .finally(() => {
          this.isLoading = false;
          this.close();
        });
    },
    /**
     * Deletes a Job
     * @author Nick Brahimir
     */
    deleteJob(): void {
      if (this.job.jobId) {
        JobsService.deleteJob(this.currentUser.clientId, this.job.jobId).then((response: any) => {
          if (!response) return;
          this.$emit("refresh-jobs");
          this.updateStore();
          this.isLoading = false;
          this.close();
        });
      }
    },
    /**
     * Reopens (uncancels) a Job
     * @author Nick Brahimir
     */
    reopenJob(): void {
      if (!this.job) return;
      this.isLoading = true;
      JobsService.reopenJob(this.currentUser.clientId, this.job)
        .then(() => {
          this.$emit("refresh-jobs");
          this.updateStore();
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async createCustomer(newCustomer: CustomerModel): Promise<void> {
      this.setCustomer(newCustomer).then((cust) => {
        this.selectedCustomer = cust;
        this.getAllCustomers();
      });
    },
    async createContact(newContact: UpdateContactModel): Promise<void> {
      const contactClient = new ContactClient();
      contactClient
        .createContact(this.currentUser.client.clientId, this.selectedCustomer!.customerId, newContact)
        .then((data) => {
          if (data.model) {
            this.contacts.push(data.model);
            this.contacts = this.contacts.sort((a, b) => (a.name! < b.name! ? -1 : 1));
            this.selectedContact = data.model;
          }
        });
    },
    async createJobSite(newJobSite: UpdateJobSiteModel): Promise<void> {
      const jobSiteClient = new JobSiteClient();
      jobSiteClient
        .createJobsite(this.currentUser.client.clientId, this.selectedCustomer!.customerId, newJobSite)
        .then((data) => {
          if (data.model) {
            this.jobSites.push(data.model);
            this.selectedJobSite = data.model;
          }
        });
    },
    getJobsiteNotes(): void {
      this.jobsiteNotes = this.selectedJobSite?.notes;
    },
    updateStore(): void {
      this.$store.dispatch("SET_UPDATE_CALENDAR", true);
      this.$store.dispatch("SET_UPDATE_DASHBOARD", true);
      this.$store.dispatch("SET_UPDATE_SCHEDULER", true);
    },
    close(): void {
      this.selectedDrivers = [] as DriverModel[];
      // Material
      this.selectedMaterial = undefined as MaterialModel | undefined;
      // Quantity
      this.selectedQuantity = undefined as QuantityModel | undefined;
      this.selectedQuantityType = QuantityType.Loads;

      // Applications
      this.selectedApplications = [] as ApplicationModel[];
      this.selectedJobType = JobType.Sling;
      this.applicationIsHourly = false;
      this.applicationIsMulti = false;
      // Quarries
      this.selectedQuarry = undefined as QuarryModel | undefined;
      // Customer
      this.selectedCustomer = undefined as CustomerModel | undefined;
      this.selectedContact = undefined as ContactModel | undefined;
      this.selectedJobSite = undefined as JobSiteModel | undefined;
      // Jobsite Details
      this.lotNumber = "";
      this.unitNumber = "";
      this.block = "";
      this.municipal = "";
      this.po = "";
      this.deliveryDetailNotes = "";
      // Delivery Details
      // Datepicker
      this.deliveryDate = moment(new Date()).format("YYYY-MM-DD");
      this.dateMenu = false;
      this.jobDuration = undefined as number | undefined;
      // Timepicker
      this.deliveryTime = moment(new Date()).format("HH:mm").toString();
      this.timePickerMenu = false;
      // Delivery Date Type
      this.selectedDeliveryDateType = DeliveryDateType.At;
      // Price Type
      this.price = "";
      this.selectedPriceType = PriceType.TonYard;
      // Notes
      this.deliveryDetails = {} as DeliveryDetailsModel;
      this.driverNotes = [] as DriverNoteModel[];
      // First Available Job Time
      this.firstAvailableTime = undefined as Date | undefined;
      this.$v.$reset();
      this.dialog = false;
      this.$emit("close");
    },
    convertTimestamp(time: Date): string {
      const parsedDate = moment(time).format("dddd, MMMM Do YYYY, h:mm A").toString();
      return parsedDate;
    },
    /**
     * Gets the first available Job time for the day (earliest Job in that day, -1 hour)
     * @author Nick Brahimir
     */
    getFirstAvailableTime(): void {
      this.isLoading = true;
      // If we're creating a new Job, set start and end for today's date.
      let date = moment(this.deliveryDate).toDate();
      let start = new Date(date.setHours(0, 0, 0, 0));
      let end = new Date(date.setHours(23, 59, 59));
      JobsService.getJobsDateRange(this.currentUser.clientId, start, end, true, false)
        .then((data: JobModel[]) => {
          if (!data) return;
          // If there's no Jobs scheduled for today, set firstAvailableTime to 6AM.
          if (!data.length) {
            this.firstAvailableTime = moment(new Date(date)).hour(6).minute(0).second(0).toDate();
            return;
          }
          // If we're updating a Job and it's the earliest Job of the day; set the firstAvailableTime to
          // the current DeliveryDate of the Job we're updating (we don't want to -1 hour if it's the
          // earliest in that day).
          if (this.job) {
            if (this.job.jobId === data[0].jobId) {
              this.firstAvailableTime = data[0].deliveryDetails!.deliveryDate;
              return;
            }
          }
          // ! If the firstAvailableTime is the previous day, default it to 12AM of the current day.
          const momentEarliestJob = moment(data[0].deliveryDetails!.deliveryDate);
          if (momentEarliestJob.hour() == 0) {
            this.firstAvailableTime = momentEarliestJob.hour(0).minute(0).second(0).toDate();
            return;
          }
          this.firstAvailableTime = momentEarliestJob.subtract(1, "hour").toDate();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * Gets the numeric difference between a start and end Date for a Job.
     * @author Nick Brahimir
     */
    getJobDuration(start: any, end?: any): number | undefined {
      if (!start || !end) return;
      const startTime = moment(start.seconds * 1000).toISOString();
      const endTime = moment(end.seconds * 1000).toISOString();
      const diffHours = moment
        .duration(moment(endTime, "YYYY/MM/DD HH:mm").diff(moment(startTime, "YYYY/MM/DD HH:mm")))
        .asHours();
      return diffHours;
    },
    showDeliveryTime(deliveryTime: DeliveryDateType): boolean {
      if (deliveryTime === DeliveryDateType.NotConfirmed) return false;
      if (deliveryTime === DeliveryDateType.WillCall) return false;
      if (deliveryTime === DeliveryDateType.Anytime) return false;
      return true;
    },
    getTaxedPrice(): number {
      const taxedPrice = parseFloat(this.price) * (1 + this.taxRate / 100);
      return Math.round(taxedPrice * 100) / 100;
    }
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    selectedCustomerErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.selectedCustomer.required && errors.push("Customer is required");
      return errors;
    },
    deliveryDateErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.deliveryDate.required && errors.push("Delivery date is required");
      return errors;
    },
    deliveryTimeErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.deliveryTime.required && errors.push("Delivery time is required");
      return errors;
    },
    selectedMaterial: {
      get(): MaterialModel | undefined {
        return this.assignedMaterial ? this.assignedMaterial.material : undefined;
      },
      set(selected: MaterialModel | null) {
        if (selected) {
          this.assignedMaterial = new JobMaterialModel({
            jobMaterialId: this.assignedMaterial?.jobMaterialId || "",
            material: selected,
            customName: this.assignedMaterial?.customName || undefined
          });
        } else {
          // User cleared the selection
          this.assignedMaterial = null;
        }
      }
    },
    selectedQuantity: {
      get(): QuantityModel | undefined {
        return this.assignedQuantity ? this.assignedQuantity.quantity : undefined;
      },
      set(selected: QuantityModel | null) {
        if (selected) {
          this.assignedQuantity = new JobQuantityModel({
            jobQuantityId: this.assignedQuantity?.jobQuantityId || "", // preserve if editing
            quantity: selected,
            customName: this.assignedQuantity?.customName || undefined
          });
        } else {
          // User cleared the selection
          this.assignedQuantity = null;
        }
      }
    },
    selectedDrivers: {
      get(): DriverModel[] {
        return this.assignedDrivers.map(
          (jobDriver: JobDriverModel) =>
            new DriverModel({
              driverId: jobDriver.driverId,
              firstName: jobDriver.firstName,
              lastName: jobDriver.lastName,
              userId: jobDriver.userId
            })
        );
      },
      set(selectedDrivers: DriverModel[]) {
        const existingDriversMap = new Map(this.assignedDrivers.map((d) => [d.driverId, d]));

        this.assignedDrivers = selectedDrivers.map((driver) => {
          const existing = existingDriversMap.get(driver.driverId);

          if (existing) {
            return existing;
          } else {
            return new JobDriverModel({
              jobDriverId: "",
              driverId: driver.driverId,
              firstName: driver.firstName,
              lastName: driver.lastName,
              userId: driver.userId,
              quarry: undefined
            });
          }
        });
      }
    }
  },
  watch: {
    deliveryDate(): void {
      this.getFirstAvailableTime();
    },
    /** Update dialog state when prop changes. */
    showDialog(newValue: boolean): void {
      this.dialog = newValue;
    },
    /** Refresh form data when new input data (scheduler) is received. */
    inputData(newValue: any): void {
      if (newValue) {
        this.initializeFormValues();
      }
    },
    /** Re-initialize form data when job prop is updated. */
    job(newValue: any): void {
      if (this.noActivators && newValue) {
        this.initializeFormValues();
      }
    }
  },
  mounted() {
    if (this.noActivators) {
      this.initializeFormValues();
    }
    if (this.showDialog) {
      this.dialog = true;
    }
  }
});
